{
    "name": "Bing Cherry",
    "binomial_name": "Prunus avium 'Bing'",
    "common_names": [
        "cherry"
    ],
    "description": "The Bing Cherry is a cultivar of the wild sweet cherry, Prunus avium, that produces large, heart-shaped, dark red fruit with firm, meaty, purplish-red flesh. The trees are available in dwarf and standard sizes. Standard trees bear fruit 5-6 years after planting, dwarf trees will bear fruit 1-3 years earlier. Plant 2-3 trees with the same bloom time for cross-pollination. Bing Cherries require a dry-summer climate for optimum harvest. Thinning is not necessary. Trees should be pruned in late winter.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Transplant sapling",
    "spread": 760,
    "row_spacing": 1050,
    "height": 1050,
    "growing_degree_days": 0,
    "companions": [
        "dill"
    ],
    "image": "/crops/images/bing-cherry.jpg",
    "icon": "/crops/icons/bing-cherry.avif"
}